import { Theme } from '@material-ui/core';

export default {};

export const overrideInputBase = (theme: Theme) => {
  if (theme.overrides && theme.overrides.MuiInputBase) {
    theme.overrides.MuiInputBase.input = {
      [theme.breakpoints.down('xs')]: {
        fontSize: '1rem',
      },
    };
  }
};
